module.exports = __webpack_public_path__ + "static/media/GOtv_Logo.b2bad1a2.png";